module.exports = __webpack_public_path__ + "static/media/advincula-product-img.604491f6.png";